import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import {
  getChatroomComposeDraft,
  saveChatroomComposeDraft,
} from '../../Chatroom.utils'

// Persists the in-progress message draft (text + attached files) to a ref owned
// by a stable ancestor and restores it on mount, so the draft survives the
// Chatroom remounting when the user toggles full screen — the inline and
// full-screen views render separate Chatroom instances, so the form would
// otherwise start empty again.
export function useChatroomInputDraft({
  draftKey,
  files,
  getDraft = getChatroomComposeDraft,
  messageDraftRef,
  saveDraft = saveChatroomComposeDraft,
  storageFiles,
  onSetFiles,
  onSetStorageFiles,
}) {
  const { setValues, values } = useFormikContext()

  const isRestoredRef = useRef(false)

  useEffect(() => {
    if (messageDraftRef) {
      if (isRestoredRef.current) {
        saveDraft(messageDraftRef, {
          files,
          key: draftKey,
          storageFiles,
          values,
        })
      } else {
        isRestoredRef.current = true

        const draft = getDraft(messageDraftRef)

        if (draft?.key === draftKey) {
          setValues(draft.values)
          onSetFiles(draft.files || EMPTY_LIST)
          onSetStorageFiles(draft.storageFiles || EMPTY_LIST)
        } else {
          saveDraft(messageDraftRef, {
            files,
            key: draftKey,
            storageFiles,
            values,
          })
        }
      }
    }
  }, [draftKey, files, storageFiles, values])
}
